module.exports = __webpack_public_path__ + "static/media/14UNEP23.dc7dbab0.jpg";